// src/components/DeleteConfirmDialog.jsx

import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

/**
 * @param {boolean} props.open          – controls visibility
 * @param {() => void} props.onClose   – called to cancel/close
 * @param {() => void} props.onConfirm – called when user confirms
 * @param {string} props.title         – e.g. “Delete League?”
 * @param {string} props.itemName      – e.g. the league name
 */
const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  itemName
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete “{itemName}”? This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button 
        onClick={onClose}
        sx={{
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          minWidth: { xs: '80px', sm: 'auto' },
          padding: { xs: '6px 12px', sm: '8px 16px' }
        }}
      >
        Cancel
      </Button>
      <Button 
        color="error" 
        onClick={onConfirm}
        sx={{
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          minWidth: { xs: '80px', sm: 'auto' },
          padding: { xs: '6px 12px', sm: '8px 16px' }
        }}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
)

export default DeleteConfirmDialog
